import { Component, OnInit } from '@angular/core';
import { ExportMode, IWizardExportPageComponent } from '@barthauer/abc/interfaces/core/wizards/wizard-export';
import { FeatureGeometryType, MapService } from '@barthauer/abc/graphics/adapters/open-layers';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { M150ExportService } from '../../m150-export.service';
import { M150WizardExportMode, M150WizardTransferObject } from '../../models/export.model';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'export-mode-selection-page',
  templateUrl: './export-mode-selection-page.component.html',
  styleUrls: ['./export-mode-selection-page.component.scss'],
  standalone: false,
})
export class ExportModeSelectionPageComponent implements OnInit, IWizardExportPageComponent {
  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;
  public selectedExportMode: ExportMode = ExportMode.VisibleArea;
  public transferObject: object;
  public selectedPolygon: number[][];
  private destroy$ = new Subject<void>();

  get isValid(): boolean {
    if (this.selectedExportMode === ExportMode.MarkedArea && !this.selectedPolygon) {
      return false;
    }

    return true;
  }

  get invalidMessage(): string {
    return this.res.get('PolygonValidationMessage');
  }

  constructor(
    private m150ExportService: M150ExportService,
    private mapService: MapService,
    private resourceService: ResourceManagerService
  ) {
    this.resAsync = this.resourceService.getResourceSet('m150-export');
  }

  async ngOnInit() {
    this.res = await this.resAsync;

    this.mapService
      .onFeatureSelectionCanceled()
      .pipe(takeUntil(this.destroy$))
      .subscribe((isCanceled) => {
        if (isCanceled) {
          this.m150ExportService.maximizeWizardWindow();
          this.m150ExportService.windowInstance?.updateShading(true);
        }
      });
  }

  public onNext(): void {
    (this.transferObject as M150WizardTransferObject).exportMode = this
      .selectedExportMode as unknown as M150WizardExportMode;
  }

  public async selectPolygon(): Promise<void> {
    this.m150ExportService.minimizeWizardWindow();
    this.m150ExportService.windowInstance?.updateShading(false);
    this.selectedPolygon = await this.mapService.startInteractiveGeometryCapture(FeatureGeometryType.Polygon);

    if (this.selectedPolygon) {
      this.m150ExportService.filterPolygon = this.selectedPolygon;
      this.m150ExportService.maximizeWizardWindow();
      this.m150ExportService.windowInstance?.updateShading(true);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
